// src/pages/Consultancy.jsx
import React from "react";
import ContactForm3 from "../components/ContactForm3";
import Footer from "../components/Footer";

export default function Consultancy() {
  return (
    <>
    <section className="min-h-screen py-20 px-6 sm:px-8 bg-[#1A1631] text-white">
      <div className="max-w-5xl mx-auto">
        {/* Back Link */}
        <a
          href="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          <span className="mr-2 text-lg">←</span> Back to main site
        </a>

        {/* Page Title */}
        <h1 className="text-4xl md:text-5xl font-bold mb-8">
          <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Consulting Services
          </span>
        </h1>

        {/* Intro Paragraph */}
        <p className="text-lg text-slate-300 mb-12 max-w-3xl">
          Whether you're designing next-generation solar cells, scaling up novel sensor technology, or looking to accelerate materials discovery,
          our team provides tailored consultancy going beyond the DiaDEM<sup>™</sup> platform. We combine decades of expertise in computational chemistry,
          materials science, and data-driven design to deliver practical insight and accelerate your R&amp;D.
        </p>

        {/* Services Section */}
        <div className="space-y-6">
          <h2 className="text-2xl font-semibold text-orange-300 mb-4">How We Help</h2>
          <ul className="list-disc list-inside text-slate-300 space-y-2">
            <li>Custom molecular screening for application-specific property targets.</li>
            <li>On-demand computational studies with expert interpretation.</li>
            <li>Design optimisation for synthesisable, high-performing materials.</li>
            <li>Computational deep dive into the more advanced stages of device development.</li>
            <li>Workshops, training, and strategic advisory for your R&amp;D team.</li>
          </ul>
        </div>

        {/* Contact CTA */}
        <div className="mt-12">
     <ContactForm3 />
          
        </div>
      </div>
    </section>
      {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>

  );
}
